<template>
  <span>
    <i
      class="fas fa-play"
      v-if="playingTrack == null || (playingTrack.uid != (track || {}).uid) || !(isPlaying)"
      @click="playTrack(track)"
    ></i>
    <i
      class="fa fa-pause"
      v-if="playingTrack !=null && (playingTrack.uid == (track || {}).uid && isPlaying)"
      @click="pauseTrack(track)"
    ></i>
  </span>
</template>
<style scoped>
  i {
    cursor: pointer;
    padding: 10px;
  }
</style>
<script>
    import EventBus from '@/eventbus/index'
    import { mapState } from 'vuex'

    export default {
        name:"PlayButton",
        props :{
            track:{type:Object}
        },
        methods:{
            playTrack : (track) => EventBus.$emit("playTrack", track),
            pauseTrack : (track) => EventBus.$emit("stopTrack", track)
        },
        computed:{
            ...mapState("tracks", ["playingTrack", "isPlaying"])
        }
    }
</script>